import React, { Component, ReactNode } from 'react';
import { Platform, DeviceType, Orientation, WriteDirection } from 'sofa-reborn-react';
import { SkapaTheme } from '@inter-ikea-kompis/themes';
import { Product } from '@ikea-aoa/component-view-3d';
import { localeService } from '../../services';
import ActionListControlEnum from '@inter-ikea-kompis/component-action-list/lib/enums/ActionListControlEnum';
import {
	ArmrestPickerButtonStyle,
	SelectedArmrestStyle,
	ArmrestWrapper,
} from './ArmrestPickerButtonStyle';
import {
	KompisActionList,
	KompisActionListItem,
	KompisFocusOutline,
} from '@inter-ikea-kompis/react-components';

type Props = {
	platform: Platform;
	deviceType: DeviceType;
	orientation: Orientation;
	writeDirection: WriteDirection;
	selectedArmrest: Product | null;
	regularArmrest: Product | null;
	onButtonClick?: () => void;
};

/**
 * React component.
 *
 */
export default class ArmrestPickerButton extends Component<Props> {
	/**
	 * React render method.
	 *
	 * @returns React node.
	 */
	public render(): ReactNode {
		const { props } = this;
		const { onButtonClick } = props;
		const imgSrc = props.selectedArmrest?.images
			? props.selectedArmrest.images[0].src
			: props.regularArmrest?.images?.[0].src;
		return (
			<ArmrestWrapper
				tabIndex={0}
				onKeyDown={(e: React.KeyboardEvent<HTMLDivElement>): void => {
					if (e.key === 'Enter' || e.key === ' ') {
						onButtonClick && onButtonClick();
					}
				}}
				id={'armrestPickerButton'}
				isPortrait={props.orientation === 'portrait'}
			>
				{props.deviceType === 'mobile' || props.deviceType === 'tablet' ? (
					<KompisFocusOutline theme={SkapaTheme}>
						<ArmrestPickerButtonStyle
							onClick={(): void => onButtonClick && onButtonClick()}
							orientation={props.orientation}
							writeDirection={props.writeDirection}
						>
							<SelectedArmrestStyle>
								<img src={imgSrc} alt={localeService.getTranslation('armrestSelectorHeader')} />
							</SelectedArmrestStyle>
						</ArmrestPickerButtonStyle>
					</KompisFocusOutline>
				) : (
					<KompisActionList>
						<KompisActionListItem
							theme={SkapaTheme}
							caption={
								props.selectedArmrest?.modelId.includes('WIDE')
									? localeService.getTranslation('armrestSelectorWide')
									: localeService.getTranslation('armrestSelectorRegular')
							}
							label={localeService.getTranslation('armrestSelectorHeader')}
							control={ActionListControlEnum.chevron}
							imageSrc={imgSrc}
							horizontalPadding={true}
							compact={props.platform === 'kiosk' ? false : true}
							onSelect={(): void => onButtonClick && onButtonClick()}
						/>
					</KompisActionList>
				)}
			</ArmrestWrapper>
		);
	}
}
